import styles from './FJUsageDetailTwo.module.less';
import FJLocalStore from '@src/store/FJLocalStore';
import FJDropdown from '@src/common/components/FJDropDown/FJDropDown.tsx';
import cionNewUrl from '@src/assets/base64/cion-new.js';
import { forwardRef, useImperativeHandle, useRef, type ComponentProps, type ReactNode, type Ref } from 'react';

export type FJUsageDetailLineItem = {
    label: string;
    value: ReactNode;
};

export type FJUsageDetailTwoProps = Pick<
    ComponentProps<typeof FJDropdown>,
    'renderTrigger' | 'offsetLeft' | 'offsetTop' | 'placement'
> & {
    list: FJUsageDetailLineItem[][];
    totalCredit: number;
};

export type FJUsageDetailTwoRef = {
    closeDropdown: () => void;
    openDropdown: () => void;
};

/** FJDropDown 尚未 forwardRef；占位类型供父组件 imperative 调用（需 Dropdown 合并 ref 后才生效） */
type DropDownImperative = {
    hide: (e?: unknown) => void;
    show: (e?: unknown) => void;
};

const FJUsageDetailTwo = forwardRef<FJUsageDetailTwoRef, FJUsageDetailTwoProps>(function FJUsageDetailTwo(
    { list, renderTrigger, totalCredit, offsetLeft, offsetTop, placement = 'topCenter' },
    ref,
) {
    const dropDownRef = useRef<DropDownImperative | null>(null);

    useImperativeHandle(ref, () => ({
        closeDropdown: () => {
            dropDownRef.current?.hide();
        },
        openDropdown: () => {
            dropDownRef.current?.show();
        },
    }));

    const _renderOverlay = (config: { ref: Ref<HTMLElement> }) => (
        <div className={styles.detail_box} onClick={e => e.stopPropagation()} ref={config.ref as Ref<HTMLDivElement>}>
            <div className={styles.title}>{FJLocalStore._('usage-details')}</div>
            {list.map((itemList, listIndex) => (
                <ul className={styles.usage_item} key={listIndex}>
                    {itemList.map((item, itemIndex) => (
                        <li key={itemIndex}>
                            <div className={styles.label}>{FJLocalStore._(item.label)}</div>
                            <div className={styles.value}>{item.value}</div>
                        </li>
                    ))}
                </ul>
            ))}

            <div className={styles.footer}>
                <div className={styles.normal_text}>{FJLocalStore._('total')}</div>
                <div className={styles.credit}>
                    <img src={cionNewUrl} alt='' />
                    <div className={styles.normal_text}>{Math.floor(totalCredit * 1000) / 1000}</div>
                </div>
            </div>
        </div>
    );

    return (
        <FJDropdown
            isTopLayer={true}
            renderTrigger={renderTrigger}
            useAnchorBody
            placement={placement}
            triggerDisplay='flex'
            trigger='hover'
            renderOverlay={_renderOverlay}
            // @ts-expect-error FJDropDownProps 未含 ref；需组件 forwardRef 后移除
            ref={dropDownRef}
            offsetLeft={offsetLeft}
            offsetTop={offsetTop}
            active
        />
    );
});

FJUsageDetailTwo.displayName = 'FJUsageDetailTwo';

export default FJUsageDetailTwo;
